import { Controller } from "@hotwired/stimulus"
import Inputmask from "inputmask"

// Маска российского номера телефона на текстовых полях :phone.
// showMaskOnHover: false — не мигать плейсхолдером до фокуса.
// clearIncomplete: false — не стирать уже сохранённые в базе номера,
// которые не идеально ложатся на маску (легаси-данные без +7 и т.п.).
export default class extends Controller {
  connect() {
    this.mask = new Inputmask("+7 (999) 999-99-99", {
      showMaskOnHover: false,
      clearIncomplete: false
    })
    this.mask.mask(this.element)
  }

  disconnect() {
    this.mask?.remove()
  }
}
